import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  menuOpen: boolean;
};

const initialState: InitialState = {
  menuOpen: false,
};

const ui = createSlice({
  name: "ui",
  initialState,
  reducers: {
    resetUiStore: () => initialState,
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.menuOpen = action.payload;
    },
  },
});

export const { resetUiStore, setMenuOpen } = ui.actions;

export default ui.reducer;
